import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {TextFieldType} from 'ui-library/inputs/EditableTextField';
import SettingsField from 'ui-library/SettingsField';

interface SchemaPrefixInputProps {
  isBeingCreated: boolean;
  isRequired: boolean;
  isWritable: boolean;
  prefix?: string | null;
  onPrefixChange: (prefix: string) => void;
  dataTestAttrs?: DataTestAttrs;
  emptyValueAllowed?: boolean;
}

export default function SchemaPrefixInput(props: SchemaPrefixInputProps): JSX.Element {
  return (
    <SettingsField
      isBeingCreated={props.isBeingCreated}
      isRequired={props.isRequired}
      isWritable={props.isWritable}
      label="Prefix"
      name="prefix"
      onChange={props.onPrefixChange}
      value={props.prefix ?? ''} // SettingsField requires a non-null value
      type={TextFieldType.TEXT}
      dataTestAttrs={props.dataTestAttrs}
      emptyValueAllowed={props.emptyValueAllowed}
    />
  );
}
